function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isUndefined from 'lodash/isUndefined';
import Structure from 'eventbrite_design_system/structure/Structure';
import CookieNotification from 'eventbrite_design_system/notification/CookieNotification';
import { SiteHeader } from '@eb/site-header';
import { SiteFooter } from '@eb/site-footer';
import { setWindowLocation } from 'js-utils/http';
import gettext from 'js-utils/gettext';
import { ENV_SHAPE_PROP_TYPE, REQUEST_SHAPE_PROP_TYPE, USER_SHAPE_PROP_TYPE, FOOTER_LINKS_SHAPE_PROP_TYPE } from './constants';

var SiteStructure =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(SiteStructure, _Component);

  function SiteStructure() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SiteStructure.prototype;

  _proto._getHeader = function _getHeader() {
    var _this$props = this.props,
        env = _this$props.env,
        request = _this$props.request,
        user = _this$props.user,
        globalHeader = _this$props.globalHeader,
        additionalHeaderContent = _this$props.additionalHeaderContent,
        hideSearchBar = _this$props.hideSearchBar,
        onSearchFocus = _this$props.onSearchFocus;
    var header = globalHeader;
    var cookieHeader;

    if (env.isEmbeddedView) {
      return null;
    } // NOTE: We need to support retrieving the `user` object via an API
    // request in order to support varnish-cached pages for logged in users.
    // See EB-39986 for more details


    if (isUndefined(header)) {
      header = React.createElement(SiteHeader, {
        env: env,
        request: request,
        user: user,
        onSearchSelect: setWindowLocation,
        hideSearchBar: hideSearchBar,
        onSearchFocus: onSearchFocus
      });
    }

    if (env.showCookieHeader) {
      // TODO: this message should be moved to:
      // /eventbrite_design_system/src/molecules/notification/constants.js
      // and used as default values on /eventbrite_design_system/src/molecules/notification/CookieNotification.js
      var cookieMessage = gettext("\n                Eventbrite, and certain approved third parties, use functional, analytical\n                and tracking cookies (or similar technologies) to understand your event preferences\n                and provide you with a customized experience. By closing this banner\n                or by continuing to use Eventbrite, you agree.");
      var cookiePolicyLink = '/cookies/';
      cookieHeader = React.createElement(CookieNotification, {
        message: cookieMessage,
        linkHref: cookiePolicyLink,
        cookieName: "acceptedCookieHeader"
      });
    }

    if (additionalHeaderContent || cookieHeader) {
      header = React.createElement("div", null, cookieHeader, header, additionalHeaderContent);
    }

    return header;
  };

  _proto._getFooter = function _getFooter() {
    var _this$props2 = this.props,
        env = _this$props2.env,
        user = _this$props2.user,
        footer = _this$props2.footer,
        footerLinks = _this$props2.footerLinks,
        showBrand = _this$props2.showBrand,
        showMarketingLinks = _this$props2.showMarketingLinks;

    if (env.isEmbeddedView) {
      return null;
    }

    if (isUndefined(footer) && footerLinks) {
      footer = React.createElement(SiteFooter, {
        serverUrl: env.serverUrl,
        locales: env.locales,
        localeInfo: env.localeInfo,
        isUserAuthenticated: user.isAuthenticated,
        popularSearches: footerLinks.popularSearches,
        eventsToPlan: footerLinks.eventsToPlan,
        thirdFooterColumn: footerLinks.thirdFooterColumn,
        thirdFooterColumnName: footerLinks.thirdFooterColumnName,
        countries: footerLinks.countries,
        showBrand: showBrand,
        showMinimalLinks: footerLinks.showMinimalLinks,
        showMarketingLinks: showMarketingLinks,
        helpLinks: env.helpUrls,
        onLocaleChange: this._handleLocaleChange.bind(this)
      });
    }

    return footer;
  };

  _proto._handleLocaleChange = function _handleLocaleChange(locale) {
    var serverUrl = this.props.env.serverUrl;
    setWindowLocation(serverUrl + "/international/change_locale/?locale=" + locale);
  };

  _proto.render = function render() {
    var structurePassThruProps = _extends({}, this.props);

    if (structurePassThruProps.env.isEmbeddedView) {
      structurePassThruProps = _objectSpread({}, structurePassThruProps, {
        pageTitle: undefined,
        navItems: undefined,
        sideDrawerDescription: undefined
      });
    } // structurePassThruProps has to be placed last
    // in case of a specific page's need to override
    // header and/or footer


    return React.createElement(Structure, _extends({
      header: this._getHeader(),
      footer: this._getFooter()
    }, structurePassThruProps));
  };

  return SiteStructure;
}(Component);

_defineProperty(SiteStructure, "propTypes", _objectSpread({}, Structure.propTypes, {
  env: ENV_SHAPE_PROP_TYPE.isRequired,
  request: REQUEST_SHAPE_PROP_TYPE.isRequired,
  user: USER_SHAPE_PROP_TYPE.isRequired,
  globalHeader: PropTypes.node,
  additionalHeaderContent: PropTypes.node,
  footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE,
  showBrand: PropTypes.bool,
  showMarketingLinks: PropTypes.bool,
  hideSearchBar: PropTypes.bool,
  onSearchFocus: PropTypes.func
}));

export { SiteStructure as default };